import {Component, DestroyRef, effect, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatDialog} from '@angular/material/dialog';
import {TmtErpOutboundPanelFilterService} from '../service/tmt-erp-outbound-panel-filter.service';
import {TmtErpOutboundFilterModalComponent} from '../components/tmt-erp-outbound-filter-modal/tmt-erp-outbound-filter-modal.component';

@Component({
  selector: 'app-tmt-erp-outbound-panel',
  templateUrl: './tmt-erp-outbound-panel.component.html',
  standalone: false,
})
export class TmtErpOutboundPanelComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly dialog = inject(MatDialog);
  private readonly filterService = inject(TmtErpOutboundPanelFilterService);

  constructor() {
    effect(() => {
      const open = this.filterService.toggleModal();
      if (!open) return;
      this.openFilters();
    });
  }

  private openFilters(): void {
    const dialog = this.dialog.open(TmtErpOutboundFilterModalComponent, {width: '700px', panelClass: 'tmt-erp-outbound-filter-dialog'});
    dialog.afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.filterService.toggleModal.set(false);
      });
  }
}
